import { fetchToken } from "../../../common/FetchCookie";
import { BASE_URL, CANDIDATE, COMPANY_REVIEW_SAVE, COMPANY_REVIEWS, EMPLOYER } from "../../../common/URLs";

const API_BASE_URL = `${BASE_URL}/${EMPLOYER}/${COMPANY_REVIEWS}`; // replace with your API base URL

export const fetchCompanyReviews = async () => {
  const url = `${API_BASE_URL}`; // Proxy path
  try {
    const token = await fetchToken()
    
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    // console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    return error
  }
};


export const updateCompanyReviews = async (uuid, data) => {
  try {
    const token = await fetchToken()

    const response = await fetch(`${API_BASE_URL}/${uuid}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error("Error updating : " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error updating : " + error.message);
  }
};

// candidate side
export const addCompanyReview = async (newCompanyReview) => {
  const url = `${BASE_URL}/${CANDIDATE}/${COMPANY_REVIEW_SAVE}`; // Proxy path
  try {
    const token = await fetchToken()

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newCompanyReview),
    });
    const data = await response.json(); 
    // console.log("API Data", data);
    return data;
  } catch (error) {
    throw error;
  }
};
